exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\n\tfont-size: 10pt;\n\tfont-weight: normal;\n\tcolor: #444;\n}\n\n.selectedRow,  .selectedRow:hover {\n\tbackground-color: #a1d6a2;\n}\n\n.inScadenza {\n\tcolor: red;\n\tfont-weight: bold;\n}\n\n.scaduto {\n\tcolor: #aaa;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/checkhr-users/checkhr-users.component.css
// module id = 324
// module chunks = 0